import { render, staticRenderFns } from "./editwarehouseinfo.vue?vue&type=template&id=cb74c0e4"
import script from "./editwarehouseinfo.vue?vue&type=script&lang=js"
export * from "./editwarehouseinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports